export default __webpack_public_path__ + "static/media/phone-bill-outline-16px.d4374fc4.svg";